module.exports = "/v2/pages/dashboard/dist/e50d4aa9f8ad11995f83f35b7f4fbcb1.svg";